const values = [
  {
    icon: "ri-equalizer-line",
    title: "追更实时同步",
    desc: "进度条与连载更新状态实时联动，一话更新立刻刷新，续读一键到位。",
    color: "bg-primary-100 text-primary-700",
  },
  {
    icon: "ri-bar-chart-line",
    title: "榜单权威实时",
    desc: "热门榜单综合人气、收藏与完读率，每 4 小时自动刷新，榜单真实可信。",
    color: "bg-secondary-100 text-secondary-800",
  },
  {
    icon: "ri-calendar-check-line",
    title: "周更稳定不断",
    desc: "长期连载固定更新日排期，追更日历一目了然，周更不断一话不落。",
    color: "bg-accent-100 text-accent-700",
  },
];

const reviews = [
  {
    name: "小鹿同学",
    tag: "追更 3 年",
    avatar: "鹿",
    text: "追更进度条真的救了我，以前总忘记看到第几话，现在打开就一目了然，更新了还会提醒。",
    color: "bg-primary-500",
  },
  {
    name: "北岛先生",
    tag: "老漫画迷",
    avatar: "岛",
    text: "热门榜单更新很及时，霸榜作品质量是真的高，每周固定更新从不鸽，追得放心。",
    color: "bg-accent-500",
  },
  {
    name: "奶糖不加糖",
    tag: "国漫爱好者",
    avatar: "糖",
    text: "分类清晰，找到同类作品特别方便，编辑推荐也经常淘到宝藏连载，爱了。",
    color: "bg-secondary-500",
  },
];

export default function About() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-sm font-semibold text-primary-700">
              <i className="ri-information-line"></i> 关于我们
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">人气连载一网打尽的追更社区</h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
              番木瓜漫画是一个专注人气连载的在线阅读社区。我们深知追更的快乐，也懂错过更新的遗憾，
              因此打造了「追更进度条实时同步、热门榜单权威刷新、长期连载周更不断」的一站式追更体验。
            </p>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              从热血冒险到古风武侠，从科幻机甲到恋爱治愈，丰富题材的人气连载在此聚合。
              无论你偏爱哪一类，打开番木瓜漫画都能快速找到心头好，不错过每一话更新。
            </p>

            <dl className="mt-8 grid grid-cols-3 gap-4">
              {[
                { v: "12800+", l: "人气连载" },
                { v: "360+", l: "周更作品" },
                { v: "9.4", l: "平均评分" },
              ].map((s) => (
                <div key={s.l} className="rounded-2xl bg-background-50 p-4 text-center">
                  <dd className="font-heading text-2xl text-primary-600">{s.v}</dd>
                  <dt className="mt-1 text-xs text-foreground-500">{s.l}</dt>
                </div>
              ))}
            </dl>
          </div>

          <div className="grid grid-cols-1 gap-5">
            {values.map((v) => (
              <div key={v.title} className="manga-card-hover flex items-start gap-4 rounded-2xl bg-background-50 p-5">
                <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl ${v.color}`}>
                  <i className={`${v.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="text-base font-bold text-foreground-950">{v.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16">
          <h3 className="text-center font-heading text-2xl text-foreground-950 md:text-3xl">读者怎么说</h3>
          <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-3">
            {reviews.map((r) => (
              <figure key={r.name} className="rounded-2xl bg-background-50 p-6">
                <div className="flex gap-1 text-secondary-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-4 text-sm leading-relaxed text-foreground-700">“{r.text}”</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-full ${r.color} font-heading text-white`}>
                    {r.avatar}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{r.name}</p>
                    <p className="text-xs text-foreground-500">{r.tag}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}